import { IPageAddCallback } from "./index";
// import { openSharedModal } from '../components/shared';
import openAddUserModal from "../contextModal/AddUserMembers";
import { lang } from "../context";
import events from "../context/events";
import { PermissionEnum } from "../const";
import {
  folderTypeEnum,
  getJoySpaceReadAllPermission,
  getJoySpaceReadFolderPermission,
  getJoySpaceReadOnlyPermission,
  getJoySpaceReadPagePermission,
  getJoySpaceReadWritePermission
} from "../config/permissions.config";
import React, { useContext, useMemo } from "react";
import { ActionFnEnum, ActionType, FileType, OpenFolderStatus } from "../types";
import { Tooltip } from "antd";

import { getAIConfigData } from "@/utils/tools";
import { getJoyspaceDucc } from "../util";
import Icon from "../Icon";
// eslint-disable-next-line max-params
const Shared: IPageAddCallback = (props, isAllow, isTeam, context) => {
  //   const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const { data, clearSelect, setData, from } = props;
  let type = data.page_type ? FileType.Page : FileType.Folder;
  let permissionType = getJoySpaceReadOnlyPermission();
  let folderType = data.type as any;
  if (folderType && folderType === folderTypeEnum.MY) {
    permissionType = getJoySpaceReadAllPermission();
  } else if (type === FileType.Page && folderType === folderTypeEnum.MY) {
    permissionType = getJoySpaceReadWritePermission();
  } else if (type === FileType.Page) {
    permissionType = getJoySpaceReadPagePermission(data.permissions);
  } else if (folderType && folderType === folderTypeEnum.SHARE && type === FileType.Folder) {
    permissionType = getJoySpaceReadFolderPermission(data.permissions);
  }

  return [
    {
      children: lang("ctx.shared.title"),
      icon: "pc_yundocument_share",
      splitCode: 1,
      callbackOrModal: () =>
        openAddUserModal({
          pageType: data.page_type || data.type,
          from,
          type,
          id: data.id,
          isModalVisible: true,
          permissionType,
          aiConfigName: getJoyspaceDucc?.()?.aiConfigName,
          title: (
            <div>
              分享给
              <Tooltip
                placement="top"
                title="如果被分享人的已有权限高于本次分享设置的权限，则该用户的权限不会被改变。如需变更用户的权限，请在“协作者管理”中设置。"
                className="joyspace-operate-tip"
              >
                <Icon type="iconquanjutishi" className="share-tip" />
              </Tooltip>
            </div>
          ),
          modalType: "share",
          folderType: folderType,
          isShowManageBtn: !(folderType === folderTypeEnum.MY && type === FileType.Folder),
          permissions: data.permissions,
          isOpenFolder:
            data.open === OpenFolderStatus.OPEN ? OpenFolderStatus.OPEN : OpenFolderStatus.CLOSE,
          onOk: () => {
            // clearSelect?.();
            events.emit("list.check");
            // const newData = {
            //   ...data,
            //   isShared: true
            // };
            // setData({
            //   type: ActionFnEnum.UPDATE,
            //   newItem: newData,
            //   id: data.id,
            //   actionType: type === FileType.Page ? ActionType.Page : ActionType.Folder
            // } as any);
          },
          onUpdata: (res) => {
            console.log("多弹窗数据同步==>", res);
            // setData({
            //   type: ActionFnEnum.UPDATE,
            //   newItem: res,
            //   id: data.id,
            //   actionType: type === FileType.Page ? ActionType.Page : ActionType.Folder
            // } as any);
            // setData({ type: ActionFnEnum.ADDMEMBERS, newItem: res, id: data.id } as any);
          }
        }),
      isAllow,
      type: "shared",
      allowTips:
        type === FileType.Page
          ? "文档已开启安全设置，您暂无权限分享"
          : "文件夹已开启安全设置，您暂无权限分享"
    }
  ];
};

export default Shared;
